import { ProductTypeFilter } from './product-type-filter';

export function ProductFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <ProductTypeFilter />
    </div>
  );
}
